'use strict';

var React = require('react');

var SvgDnsSettingsIcon = function SvgDnsSettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.5 5.25c0-.966.783-1.75 1.75-1.75h9.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-9.5a1.75 1.75 0 0 1-1.75-1.75v-2.5Zm1.75-.25a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25h-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 12a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h5a.75.75 0 0 1 0 1.5h-5a1.75 1.75 0 0 1-1.75-1.75v-2.5c0-.966.783-1.75 1.75-1.75h6.75a.75.75 0 0 1 0 1.5h-6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.878 13.839a2.257 2.257 0 0 1 0 .822l.327.19a.75.75 0 0 1-.75 1.298l-.328-.189a2.245 2.245 0 0 1-.712.412v.378a.75.75 0 0 1-1.5 0v-.378a2.248 2.248 0 0 1-.712-.412l-.328.19a.75.75 0 0 1-.75-1.3l.328-.188a2.26 2.26 0 0 1 0-.824l-.328-.189a.75.75 0 0 1 .75-1.299l.328.19a2.25 2.25 0 0 1 .712-.412v-.378a.75.75 0 0 1 1.5 0v.378c.263.093.504.234.712.412l.328-.19a.75.75 0 0 1 .75 1.3l-.327.189Zm-2.963.411c0-.133.035-.258.096-.367l.005-.008.004-.008a.75.75 0 0 1 1.289-.002l.006.01.006.01a.747.747 0 0 1 0 .73l-.006.01-.006.01a.75.75 0 0 1-1.29-.002l-.003-.008-.005-.008a.747.747 0 0 1-.096-.367Z"
  }));
};
SvgDnsSettingsIcon.displayName = "DnsSettingsIcon";

exports.SvgDnsSettingsIcon = SvgDnsSettingsIcon;
